import { Box, styled } from '@mui/material';
import {
  COLUMN_INDICATOR_ADJUSTMENT,
  COLUMN_INDICATOR_HEIGHT,
} from 'components/ScalarSpreadsheet/components/content-column/ContentColumns.util';
import theme from 'theme';

const MOON_BOX_SHADOW_POSITION = '10px 0 0 0';
const MOON_X_OFFSET = '1px';

// Prevents the fake scrollbar from affecting layout
export const StyledWrapper = styled(Box)(() => ({
  height: '100%',
  overflow: 'clip',
  overflowAnchor: 'none', // prevents scroll anchoring jumps
  paddingBottom: `${COLUMN_INDICATOR_HEIGHT * 2}px`,
  position: 'relative',
  width: '100%',
  '&::before, &::after': {
    borderRadius: '50%',
    bottom: '-5px',
    content: '""',
    height: '20px',
    mixBlendMode: 'lighten',
    pointerEvents: 'none',
    position: 'absolute',
    width: '40px',
    zIndex: 2,
  },
  // Trail border radius (left moon)
  '&::before': {
    boxShadow: `-${MOON_BOX_SHADOW_POSITION} ${theme.palette.common.white}`,
    left: MOON_X_OFFSET,
  },
  // Trail border radius (right moon)
  '&::after': {
    boxShadow: `${MOON_BOX_SHADOW_POSITION} ${theme.palette.common.white}`,
    right: MOON_X_OFFSET,
  },
  // Hide pseudo-elements when horizontal scroll is suppressed
  '&[data-suppress-scroll-x="true"]::before': {
    display: 'none',
  },
  '&[data-suppress-scroll-x="true"]::after': {
    display: 'none',
  },
}));

// Real content with hidden native scrollbar
export const StyledContent = styled(Box)(() => ({
  height: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  paddingTop: COLUMN_INDICATOR_ADJUSTMENT,
  position: 'relative',
  scrollbarWidth: 'none',
  width: '100%',
  overflowAnchor: 'none', // prevents scroll anchoring jumps
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

// Fake horizontal scrollbar (always visible)
export const StyledScrollbar = styled(Box)(() => ({
  backgroundColor: theme.palette.scrollbarTrack,
  bottom: '0',
  height: '10px',
  left: 0,
  overflowX: 'auto',
  overflowY: 'hidden',
  position: 'absolute',
  transition: 'background-color 0.15s ease',
  width: '100%',
  zIndex: 1,
  // Chrome / Safari / Edge
  '&::-webkit-scrollbar': {
    height: '10px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.scrollbarThumb,
    borderRadius: '6px',
    transition: 'background-color 0.15s ease',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: theme.palette.scrollbarTrack,
  },
  // Firefox-only safe block
  '@-moz-document url-prefix()': {
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.scrollbarThumb} ${theme.palette.scrollbarTrack}`,
  },
}));

// Inner element for scrollWidth sync
export const StyledInner = styled(Box)(() => ({
  background: 'transparent',
  height: '1px',
}));
